import * as React from "react"

import { FieldItems, ReadOnly } from "@tenforce/toolbox-field-react"
import { Symbols } from "@tenforce/toolbox-fontmap"

export const LoadingPlaceholder = (): JSX.Element => (
    <FieldItems
        label={Symbols.PlaceholderMedium}
        extraClasses="is-loading"
        data-ft-component="loadingPlaceholder"
    >
        <ReadOnly
            value={`${Symbols.PlaceholderSmall} ${Symbols.PlaceholderBig} ${Symbols.PlaceholderTiny}`}
            extraClasses="is-dimmed"
        />
    </FieldItems>
)

export default LoadingPlaceholder
